import { Skeleton, TableCell, TableRow } from "@mui/material";
import type { FunctionComponent } from "react";

export interface SearchResultsLoadingProps {
  rows?: number;
}

export const SearchResultsLoadingTableRow: FunctionComponent<
  SearchResultsLoadingProps
> = ({ rows = 3 }) => {
  return (
    <TableRow>
      <TableCell colSpan={100}>
        {new Array(rows).fill(undefined).map((_, idx) => (
          <Skeleton height={60} key={idx} />
        ))}
      </TableCell>
    </TableRow>
  );
};
